/**
  * теперь этот файл/поток будет кодироваться в UTF-8
  */
import { } from 'main.core';
import './style.css';
import './modules/bonusStore';
// import './sku_bonus_toggle_button';
import './components/bonus_checkbox/script';
import './components/bonus_selector/script';
import './components/sku_bonus_toggle_button/script';
import './components/contragent_bonus_icon/script';
